import {
  BREAKPOINT_DESKTOP,
  BREAKPOINT_DESKTOP_XL,
} from "../../../../constants/constants";

import { css } from "styled-components/macro";
import ErrorBoundary from "components/SimpleComponents/Errors/ErrorBoundary";
import RangeSelectorConfig from "components/Dashboard/range-selectors/RangeSelectorConfig";
import CardWithControls from "components/Dashboard/CardWithControls/CardWithControls";
import RangeSelector from "components/Dashboard/range-selectors/RangeSelector";

export function RangeSelectorCard() {
  return (
    <CardWithControls
      title=""
      className="Card_RangeSelector Card_RangeSelector_TimelinePage"
      customCss={css`
        [class*="CardTopbarStyles"] {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          width: 100%;
          margin-top: 0px;
          transform: translate(1px, 1px);
          @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
            transform: translate(5px, 1px);
          }
        }
        .cardTopbar {
          background: none;
        }
        .cardConfigControls {
          margin-right: 4px;
        }
        padding: 16px;
        overflow: visible;
        @media (min-width: ${BREAKPOINT_DESKTOP}px) {
          padding: 16px 64px;
          [class*="CardTopbarStyles"] {
            margin-right: -64px;
          }
        }

        &&& {
          margin-top: 10px;
        }
      `}
      shouldOverlayTitle={true}
      shouldCenterTitle={true}
      CardConfigControls={<RangeSelectorConfig />}
    >
      <ErrorBoundary small={true} id="RangeSelector">
        <RangeSelector />
      </ErrorBoundary>
    </CardWithControls>
  );
}
